import PropTypes from 'prop-types';
import { Loader } from '../../../common/components';
import NoData from '../utils/no-data';
import DashboardGarphCardLayout from './graphLayout';
import BarGraph from './graphs/BarGraph';

const isChartValue = (value) => typeof value === 'number' && Number.isFinite(value);

const hasSeriesData = (series) => {
  if (!Array.isArray(series)) return false;

  return series.some((item) => {
    return Array.isArray(item?.data) && item.data.some(isChartValue);
  });
};

function ARAgingGraph({ id, data, loader }) {
  const dataAvail = hasSeriesData(data.series);
  return (
    <DashboardGarphCardLayout
      title={data.title}
      tooltip={data.tooltip}
      impNote={dataAvail ? data.impNote : ''}
      redirection={{
        ...data.redirection,
        enabled: dataAvail && data.redirection.enabled,
      }}
    >
      {loader && <Loader />}
      {!loader && dataAvail && <BarGraph id={id} data={data} />}
      {!loader && !dataAvail && <NoData />}
    </DashboardGarphCardLayout>
  );
}

ARAgingGraph.propTypes = {
  id: PropTypes.string.isRequired,
  loader: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired,
    graphColor: PropTypes.shape([]).isRequired,
    impNote: PropTypes.string.isRequired,
    series: PropTypes.shape([]).isRequired,
    redirection: PropTypes.shape({
      enabled: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
};

export default ARAgingGraph;
